import React from "react";
import { toast } from "sonner";
import { Bell, CheckCheck } from "lucide-react";
import { api } from "../lib/api";
import { useApiQuery, useQueryClient } from "../lib/useApiQuery";
import { Loader, EmptyState } from "../components/Loader";
import { PageHeader } from "../components/PageHeader";

export default function Notifications() {
  const qc = useQueryClient();
  const { data: items = [], isLoading } = useApiQuery(["notifications"], "/notifications/mine", { staleTime: 10000 });
  const reload = () => qc.invalidateQueries({ queryKey: ["notifications"] });

  const markAll = async () => {
    try { await api("/notifications/read-all", { method: "PUT" }); reload(); } catch (e) { toast.error(e.message); }
  };
  const readOne = async (n) => {
    if (n.read) return;
    try { await api(`/notifications/${n.notification_id}/read`, { method: "PUT" }); reload(); } catch {}
  };

  if (isLoading) return <Loader />;

  return (
    <div className="animate-fade-in-up max-w-2xl mx-auto">
      <PageHeader title="الإشعارات" right={items.length > 0 ? <button data-testid="mark-all-read" onClick={markAll} className="flex items-center gap-1.5 text-sm font-bold text-[#FF3D5A]"><CheckCheck size={16} /> تعليم الكل</button> : null} />
      {items.length === 0 ? (
        <EmptyState icon={Bell} title="لا توجد إشعارات" />
      ) : (
        <div className="space-y-2.5">
          {items.map((n) => (
            <button key={n.notification_id} data-testid={`notif-${n.notification_id}`} onClick={() => readOne(n)} className={`w-full text-start p-4 rounded-2xl border ${n.read ? "bg-white border-[#E8EAF2]" : "bg-[#FFE5EA] border-[#FF3D5A]/30"}`}>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-[#FF3D5A] text-white flex items-center justify-center shrink-0"><Bell size={18} /></div>
                <div className="flex-1 min-w-0">
                  <p className="font-black text-[#161629]">{n.title}</p>
                  <p className="text-sm text-[#6B7280] mt-0.5">{n.body}</p>
                </div>
                {!n.read && <span className="w-2.5 h-2.5 rounded-full bg-[#FF3D5A] shrink-0 mt-1" />}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
